<template>
  <div class="adjacent">
    <div class="next">
      <a
        v-if="adjacent.next"
        :href="adjacent.next.url"
        >&lt; {{ adjacent.next.title }}</a>
    </div>
    <div class="parent">
      <a 
        v-if="adjacent.parent"
        :href="adjacent.parent.url"
      >{{ adjacent.parent.title }}</a>
    </div>
    <div class="prev">
      <a
        v-if="adjacent.prev"
        :href="adjacent.prev.url"
      >{{ adjacent.prev.title }} &gt;</a>
    </div>
  </div>
</template>


<script>
export default {
  name: "fcwpAdjacent",
  props: ["adjacent"]
};
</script>

<style lang="scss">
.adjacent {
  display: table;
  border-top: 1px solid rgb($quinary-color);
  padding-top: 10px;
  width: 100%;
  font-size: smaller;
  a:hover {
    text-decoration: underline rgb($secondary-color);
  }
}

.prev,
.next,
.parent {
  width: 33.33333%;
  display: inline-block;
}

.prev {
  text-align: right;
  float: right;
}

.parent {
  text-align: center;
}
</style>
